import { registerPbrTransmission } from './pbr-transmission-ext.js';
import { _registerPbrSceneHook } from './pbr-flags.js';

function setPbrTransmission(mat, refraction) {
  mat._transmissive = true;
  (mat._subsurface ??= {}).refraction = refraction;
  _registerPbrSceneHook(registerPbrTransmission);
}

export { setPbrTransmission };
//# sourceMappingURL=set-transmission.js.map
